module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-wilbert.json
// module id = 417
// module chunks = 98831230269852